var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-message"},[_vm._v(" 视频消息 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }